
class LoginResult {
  token: string
}

export {
  LoginResult
}



// WEBPACK FOOTER //
// ./src/types/login-result.js